import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { CONTACT } from '../mock';

/**
 * Floating WhatsApp CTA button with pulse ring, tooltip and dismissable tag.
 */
export default function WhatsAppFloat() {
  const [showTag, setShowTag] = useState(true);
  const [hovering, setHovering] = useState(false);

  return (
    <div className="fixed bottom-24 right-5 z-40">
      {/* Speech bubble tag */}
      {showTag && (
        <div className="absolute bottom-full right-0 mb-3 flex items-start gap-2 fade-up">
          <div
            className="relative bg-white rounded-2xl shadow-xl border border-slate-100 px-4 py-2.5 pr-9 w-52"
            style={{ animation: 'fadeUp 400ms ease both' }}
          >
            <div className="text-xs font-semibold" style={{ color: '#25d366' }}>Hallo! 👋</div>
            <div className="text-sm font-bold leading-tight" style={{ color: '#1a3a5c' }}>Frag uns direkt auf WhatsApp!</div>
            <button
              onClick={(e) => { e.preventDefault(); setShowTag(false); }}
              className="absolute top-2 right-2 h-5 w-5 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
              aria-label="Schließen"
            >
              <X className="h-3 w-3 text-slate-600" />
            </button>
            {/* Bubble tail */}
            <div className="absolute -bottom-1.5 right-6 w-3 h-3 bg-white border-r border-b border-slate-100 transform rotate-45" />
          </div>
        </div>
      )}

      {/* Tooltip on hover */}
      {hovering && !showTag && (
        <div
          className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-slate-900 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg"
          style={{ animation: 'fadeUp 220ms ease both' }}
        >
          Auf WhatsApp schreiben
          <div className="absolute -right-1 top-1/2 -translate-y-1/2 w-2 h-2 bg-slate-900 rotate-45" />
        </div>
      )}

      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp Kontakt"
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className="relative h-14 w-14 rounded-full flex items-center justify-center shadow-xl transition-transform hover:scale-110"
        style={{ background: 'linear-gradient(180deg, #25d366 0%, #1eb85a 100%)' }}
      >
        {/* Stronger dual pulse ring */}
        <span className="absolute inset-0 rounded-full animate-ping" style={{ background: '#25d366', opacity: 0.5, animationDuration: '2s' }} />
        <span className="absolute inset-0 rounded-full animate-ping" style={{ background: '#25d366', opacity: 0.3, animationDuration: '2.6s', animationDelay: '0.4s' }} />
        <MessageCircle className="h-6 w-6 text-white relative z-10" />
      </a>
    </div>
  );
}
